import { VariantReader } from "aldoo-ra/VariantReader"
import { twMerge } from "tailwind-merge"

export default function Badge({
  variant = "default",
  styleOverrides,
  children,
  className = "",
  ...props
}) {
  const variants = VariantReader.useVariant({
    componentName: "Badge",
    variant,
    styleOverrides,
  })

  return (
    <span
      className={twMerge(variants, className)}
      {...props}
    >
      {children}
    </span>
  )
}